<template>
  <div class="login-block auth-shell">
    <div class="col-10 col-sm-8 col-xl-3">
      <el-card class="auth-card">
        <div class="card-title auth-title fs-4 pb-3">
          Сброс пароля
        </div>
        <el-form
          size="large"
          ref="form"
          class="text-start auth-form"
          status-icon
          label-width="auto">
          <el-form-item prop="password"
                        :rules="[{ required: true, message: 'Введите новый пароль' }]">
            <el-input
              :prefix-icon="Lock"
              placeholder="Новый пароль"
              v-model="password"
              type="password"
              autocomplete="off"
              show-password
            />
          </el-form-item>
          <el-form-item prop="confirm"
                        :rules="[{ required: true, message: 'Подтвердите пароль' }]">
            <el-input
              :prefix-icon="Lock"
              placeholder="Подтвердите пароль"
              v-model="confirm"
              type="password"
              autocomplete="off"
              show-password
            />
          </el-form-item>
          <el-form-item>
            <div class="w-100 text-end">
              <el-button class="auth-submit" :loading="loading" @click="submit">Сбросить пароль</el-button>
            </div>
          </el-form-item>
          <div v-if="error" class="auth-message auth-message--error text-center mb-2">{{ error }}</div>
          <div v-if="success" class="auth-message auth-message--success text-center mb-2">Пароль успешно сброшен!</div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import { Lock } from '@element-plus/icons-vue'

export default {
  data() {
    return {
      token: '',
      password: '',
      confirm: '',
      error: '',
      success: false,
      loading: false
    }
  },
  created() {
    this.token = this.$route.query.token || ''
  },
  methods: {
    async submit() {
      this.error = ''
      this.success = false

      if (!this.password || !this.confirm) {
        this.error = 'Пожалуйста, заполните оба поля.'
        return
      }

      if (this.password !== this.confirm) {
        this.error = 'Пароли не совпадают.'
        return
      }

      if (!this.token) {
        this.error = 'Токен отсутствует.'
        return
      }

      this.loading = true

      try {
        const res = await this.$store.dispatch('auth/resetPassword', {
          token: this.token,
          password: this.password
        })
        if (res?.success) {
          this.success = true
          await this.$store.commit('auth/SET_TOKEN', res.token)
          await this.$store.dispatch('auth/getUserInfo')
          await this.$store.commit('auth/SET_IS_LOGIN', true)
          this.$router.push('/')
        } else {
          this.error = res?.message || 'Ошибка сброса пароля.'
        }
      } catch (err) {
        this.error = err?.message || 'Ошибка сброса пароля.'
      } finally {
        this.loading = false
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    toggleConfirmVisibility() {
      this.showConfirm = !this.showConfirm
    }
  },
  computed: {
    Lock() {
      return Lock
    }
  }
}
</script>
<style scoped>
.login-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.alt-link {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
}
</style>
